import mountVueInstance from './mountVueInstance'

function errorLoadPage (
  Vue,
  ErrorPage,
  errorCode = '500',
  errorText = 'Server exception. Please contact administrator.',
  vueOptions) {
  mountVueInstance(Vue, {
    render: h => h(ErrorPage, { props: { code: errorCode, text: errorText }}, null)
  }, vueOptions)
}

export default errorLoadPage
